/** constants */
export const A4_SHORT_SIDE = 595.28;
export const A4_LONG_SIDE = 841.89;
export const WIDTH_MARGIN = 10;
export const HEIGHT_MARGIN = 10;
